import { DtoId } from '@/shared/lib/sj-orm/models/base.dto';

export const routes = {
  assets: () => '/assets',
  asset: (id: DtoId) => `/assets/${id}`,
  beneficiaries: () => '/beneficiaries',
  beneficiary: (id: DtoId) => `/beneficiaries/${id}`,
  personalIds: () => '/personal-identifiers',
  personalId: (id: DtoId) => `/personal-identifiers/${id}`,
  privateDocuments: () => '/documents/private',
  privateDocument: (id: DtoId) => `/documents/${id}`,
  contacts: () => '/contacts',
  contact: (id: DtoId) => `/contacts/${id}`,
};
